import React, { useState } from "react";
import "./RentalIncome.css";
import CustomDropdown from "../../../../../Components/CustomDropdown/CustomDropdown";
import { Checkbox, FormControlLabel, Radio, RadioGroup } from "@mui/material";

const RentalIncome = () => {
  return (
    <div className="cltdetails__rentalincome_page">
      <div className="cltdetails__rentalincome_contentwrap">
        <div className="cltdetails__rentalincome_contentbox">
          <div
            className="cltdetails__rentalincome_cboxheader"
            style={{ background: "rgba(5, 89, 91, 0.75)" }}
          >
            Rental Income Info
          </div>
          <div className="cltdetails__rentalincome_cboxbody">
            <div className="cltdetails__rentalincome_cboxrow">
              <div className="cltdetails__rentalincome_cboxcol">
                <div className="cltdetails__rentalincome_cboxfieldbox">
                  <label className="cltdetails__rentalincome_cboxfieldlbl">
                    Building value
                  </label>
                  <div className="cltdetails__rentalincome_cboxfieldwrap">
                    <input
                      type="text"
                      className="cltdetails__rentalincome_cboxfield"
                      placeholder="US$"
                    />
                  </div>
                </div>
              </div>
              <div className="cltdetails__rentalincome_cboxcol">
                <div className="cltdetails__rentalincome_cboxfieldbox">
                  <label className="cltdetails__rentalincome_cboxfieldlbl">
                    Land Value
                  </label>
                  <div className="cltdetails__rentalincome_cboxfieldwrap">
                    <input
                      type="text"
                      className="cltdetails__rentalincome_cboxfield"
                      placeholder="US$"
                    />
                  </div>
                </div>
              </div>
              <div className="cltdetails__rentalincome_cboxcol">
                <div className="cltdetails__rentalincome_cboxfieldbox">
                  <label className="cltdetails__rentalincome_cboxfieldlbl">
                    Address of the property
                  </label>
                  <div className="cltdetails__rentalincome_cboxfieldwrap">
                    <input
                      type="text"
                      className="cltdetails__rentalincome_cboxfield"
                      placeholder="123 Example St., City, State"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="cltdetails__rentalincome_cboxrow">
              <div className="cltdetails__rentalincome_cboxcol">
                <div className="cltdetails__rentalincome_cboxfieldbox">
                  <label className="cltdetails__rentalincome_cboxfieldlbl">
                    Number of days rented during the year
                  </label>
                  <div className="cltdetails__rentalincome_cboxfieldwrap">
                    <input
                      type="number"
                      className="cltdetails__rentalincome_cboxfield"
                      placeholder="Enter Number"
                    />
                  </div>
                </div>
              </div>
              <div className="cltdetails__rentalincome_cboxcol">
                <div className="cltdetails__rentalincome_cboxfieldbox">
                  <label className="cltdetails__rentalincome_cboxfieldlbl">
                    Date of property Purchased
                  </label>
                  <div className="cltdetails__rentalincome_cboxfieldwrap">
                    <input
                      type="date"
                      className="cltdetails__rentalincome_cboxfield"
                    />
                  </div>
                </div>
              </div>
              <div className="cltdetails__rentalincome_cboxcol">
                <div className="cltdetails__rentalincome_cboxfieldbox">
                  <label className="cltdetails__rentalincome_cboxfieldlbl">
                    Property holder
                  </label>
                  <div className="cltdetails__rentalincome_cboxfieldwrap">
                    <input
                      type="text"
                      className="cltdetails__rentalincome_cboxfield"
                      placeholder="Enter Name"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="cltdetails__rentalincome_cboxrow">
              <div className="cltdetails__rentalincome_cboxcol">
                <div className="cltdetails__rentalincome_cboxfieldbox">
                  <label className="cltdetails__rentalincome_cboxfieldlbl">
                    Account Number
                  </label>
                  <div className="cltdetails__rentalincome_cboxfieldwrap">
                    <input
                      type="text"
                      className="cltdetails__rentalincome_cboxfield"
                      placeholder="Enter Account Number"
                    />
                  </div>
                </div>
              </div>
              <div className="cltdetails__rentalincome_cboxcol">
                <div className="cltdetails__rentalincome_cboxfieldbox">
                  <label className="cltdetails__rentalincome_cboxfieldlbl">
                    Income
                  </label>
                  <div className="cltdetails__rentalincome_cboxfieldwrap">
                    <input
                      type="text"
                      className="cltdetails__rentalincome_cboxfield"
                      placeholder="$"
                    />
                  </div>
                </div>
              </div>
              <div className="cltdetails__rentalincome_cboxcol">
                <div className="cltdetails__rentalincome_cboxfieldbox">
                  <label className="cltdetails__rentalincome_cboxfieldlbl">
                    Rents Received
                  </label>
                  <div className="cltdetails__rentalincome_cboxfieldwrap">
                    <input
                      type="text"
                      className="cltdetails__rentalincome_cboxfield"
                      placeholder="Enter Value"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="cltdetails__rentalincome_cboxrow">
              <div className="cltdetails__rentalincome_cboxcol">
                <div className="cltdetails__rentalincome_cboxfieldbox">
                  <label className="cltdetails__rentalincome_cboxfieldlbl">
                    Royalties Received
                  </label>
                  <div className="cltdetails__rentalincome_cboxfieldwrap">
                    <input
                      type="text"
                      className="cltdetails__rentalincome_cboxfield"
                      placeholder="Enter Value"
                    />
                  </div>
                </div>
              </div>
              <div className="cltdetails__rentalincome_cboxcol">
                <div className="cltdetails__rentalincome_cboxfieldbox">
                  <label className="cltdetails__rentalincome_cboxfieldlbl">
                    Expenses
                  </label>
                  <div className="cltdetails__rentalincome_cboxfieldwrap">
                    <input
                      type="text"
                      className="cltdetails__rentalincome_cboxfield"
                      placeholder="$"
                    />
                  </div>
                </div>
              </div>
              <div className="cltdetails__rentalincome_cboxcol">
                <div className="cltdetails__rentalincome_cboxfieldbox">
                  <label className="cltdetails__rentalincome_cboxfieldlbl">
                    Mortgage Interest
                  </label>
                  <div className="cltdetails__rentalincome_cboxfieldwrap">
                    <input
                      type="text"
                      className="cltdetails__rentalincome_cboxfield"
                      placeholder="Enter Value"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="cltdetails__rentalincome_cboxrow">
              <div className="cltdetails__rentalincome_cboxcol">
                <div className="cltdetails__rentalincome_cboxfieldbox">
                  <label className="cltdetails__rentalincome_cboxfieldlbl">
                    Other Interest
                  </label>
                  <div className="cltdetails__rentalincome_cboxfieldwrap">
                    <input
                      type="text"
                      className="cltdetails__rentalincome_cboxfield"
                      placeholder="Enter Value"
                    />
                  </div>
                </div>
              </div>
              <div className="cltdetails__rentalincome_cboxcol">
                <div className="cltdetails__rentalincome_cboxfieldbox">
                  <label className="cltdetails__rentalincome_cboxfieldlbl">
                    Insurance
                  </label>
                  <div className="cltdetails__rentalincome_cboxfieldwrap">
                    <input
                      type="text"
                      className="cltdetails__rentalincome_cboxfield"
                      placeholder="Enter Value"
                    />
                  </div>
                </div>
              </div>
              <div className="cltdetails__rentalincome_cboxcol">
                <div className="cltdetails__rentalincome_cboxfieldbox">
                  <label className="cltdetails__rentalincome_cboxfieldlbl">
                    Repairs
                  </label>
                  <div className="cltdetails__rentalincome_cboxfieldwrap">
                    <input
                      type="text"
                      className="cltdetails__rentalincome_cboxfield"
                      placeholder="Enter Value"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="cltdetails__rentalincome_cboxrow">
              <div className="cltdetails__rentalincome_cboxcol">
                <div className="cltdetails__rentalincome_cboxfieldbox">
                  <label className="cltdetails__rentalincome_cboxfieldlbl">
                    Auto & Travel
                  </label>
                  <div className="cltdetails__rentalincome_cboxfieldwrap">
                    <input
                      type="text"
                      className="cltdetails__rentalincome_cboxfield"
                      placeholder="Enter Value"
                    />
                  </div>
                </div>
              </div>
              <div className="cltdetails__rentalincome_cboxcol">
                <div className="cltdetails__rentalincome_cboxfieldbox">
                  <label className="cltdetails__rentalincome_cboxfieldlbl">
                    Advertising
                  </label>
                  <div className="cltdetails__rentalincome_cboxfieldwrap">
                    <input
                      type="text"
                      className="cltdetails__rentalincome_cboxfield"
                      placeholder="Enter Value"
                    />
                  </div>
                </div>
              </div>
              <div className="cltdetails__rentalincome_cboxcol">
                <div className="cltdetails__rentalincome_cboxfieldbox">
                  <label className="cltdetails__rentalincome_cboxfieldlbl">
                    Taxes
                  </label>
                  <div className="cltdetails__rentalincome_cboxfieldwrap">
                    <input
                      type="text"
                      className="cltdetails__rentalincome_cboxfield"
                      placeholder="Enter Value"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="cltdetails__rentalincome_cboxrow">
              <div className="cltdetails__rentalincome_cboxcol">
                <div className="cltdetails__rentalincome_cboxfieldbox">
                  <label className="cltdetails__rentalincome_cboxfieldlbl">
                    Legal & Other Professional Fees
                  </label>
                  <div className="cltdetails__rentalincome_cboxfieldwrap">
                    <input
                      type="text"
                      className="cltdetails__rentalincome_cboxfield"
                      placeholder="Enter Value"
                    />
                  </div>
                </div>
              </div>
              <div className="cltdetails__rentalincome_cboxcol">
                <div className="cltdetails__rentalincome_cboxfieldbox">
                  <label className="cltdetails__rentalincome_cboxfieldlbl">
                    Cleaning & Maintenance
                  </label>
                  <div className="cltdetails__rentalincome_cboxfieldwrap">
                    <input
                      type="text"
                      className="cltdetails__rentalincome_cboxfield"
                      placeholder="Enter Value"
                    />
                  </div>
                </div>
              </div>
              <div className="cltdetails__rentalincome_cboxcol">
                <div className="cltdetails__rentalincome_cboxfieldbox">
                  <label className="cltdetails__rentalincome_cboxfieldlbl">
                    Commissions
                  </label>
                  <div className="cltdetails__rentalincome_cboxfieldwrap">
                    <input
                      type="text"
                      className="cltdetails__rentalincome_cboxfield"
                      placeholder="Enter Value"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="cltdetails__rentalincome_cboxrow">
              <div className="cltdetails__rentalincome_cboxcol">
                <div className="cltdetails__rentalincome_cboxfieldbox">
                  <label className="cltdetails__rentalincome_cboxfieldlbl">
                    Utilities
                  </label>
                  <div className="cltdetails__rentalincome_cboxfieldwrap">
                    <input
                      type="text"
                      className="cltdetails__rentalincome_cboxfield"
                      placeholder="Enter Value"
                    />
                  </div>
                </div>
              </div>
              <div className="cltdetails__rentalincome_cboxcol">
                <div className="cltdetails__rentalincome_cboxfieldbox">
                  <label className="cltdetails__rentalincome_cboxfieldlbl">
                    Management Fees
                  </label>
                  <div className="cltdetails__rentalincome_cboxfieldwrap">
                    <input
                      type="text"
                      className="cltdetails__rentalincome_cboxfield"
                      placeholder="Enter Value"
                    />
                  </div>
                </div>
              </div>
              <div className="cltdetails__rentalincome_cboxcol">
                <div className="cltdetails__rentalincome_cboxfieldbox">
                  <label className="cltdetails__rentalincome_cboxfieldlbl">
                    Supplies
                  </label>
                  <div className="cltdetails__rentalincome_cboxfieldwrap">
                    <input
                      type="text"
                      className="cltdetails__rentalincome_cboxfield"
                      placeholder="Enter Value"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="cltdetails__rentalincome_cboxrow">
              <div className="cltdetails__rentalincome_cboxcol">
                <div className="cltdetails__rentalincome_cboxfieldbox">
                  <label className="cltdetails__rentalincome_cboxfieldlbl">
                    Other Expenses
                  </label>
                  <div className="cltdetails__rentalincome_cboxfieldwrap">
                    <input
                      type="text"
                      className="cltdetails__rentalincome_cboxfield"
                      placeholder="Enter Value"
                    />
                  </div>
                </div>
              </div>
              <div className="cltdetails__rentalincome_cboxcol"></div>
              <div className="cltdetails__rentalincome_cboxcol"></div>
            </div>
          </div>
        </div>
        <div
          className="cltdetails__rentalincome_checkboxitm2"
          style={{ border: "none" }}
        >
          <div className="cltdetails__rentalincome_cbicbox">
            {" "}
            <Checkbox
              defaultChecked
              sx={{
                "&.Mui-checked": {
                  color: "rgba(29, 66, 102, 1)",
                },
              }}
            />
          </div>
          <div className="cltdetails__rentalincome_cbirttxt">
            I declare that the information in this application is true and
            correct
          </div>
        </div>
        <div className="cltdetails__rentalincome_savebtnwrap">
          <button className="cltdetails__rentalincome_savebtn">Save</button>
        </div>
      </div>
      <div className="cltdetails__rentalincome_contentwrap">
        <div className="cltdetails__rentalincome_bottombtns">
          <button className="cltdetails__rentalincome_bbtnfilled">
            Submit
          </button>
          <button className="cltdetails__rentalincome_bbtnoutlined">
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default RentalIncome;
